// extracted by mini-css-extract-plugin
export var notificationHost = "_gy-0";